// extracted by mini-css-extract-plugin
export default {"table":"Table__table___s8jIF","caption":"Table__caption___kDcJr","cell":"Table__cell___oIWGE","headerCell":"Table__headerCell___jZdB0","header":"Table__header___toK4C"};